import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressCircleComponent } from './progress-circle.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ ProgressCircleComponent ],
    declarations: [ ProgressCircleComponent ],
})
export class ProgressCircleModule {}
